import React from 'react';

const SplashScreen = () => {
  return (
    <div
      className="fixed inset-0 z-[9999] flex items-center justify-center bg-gradient-to-br from-[#052e2b] via-[#0f766e] to-[#065f46]"
    >
      <div className="text-center">
        <img
          src="/icon-512.png"
          alt="UttaApp Logo"
          className="w-32 h-32 md:w-40 md:h-40 mx-auto mb-4 drop-shadow-2xl"
        />
        <h1 className="text-3xl md:text-4xl font-bold text-white mt-4">
          UttaApp
        </h1>
        <div className="mx-auto mt-6 h-10 w-10 animate-spin rounded-full border-4 border-white/20 border-t-white" />
      </div>
    </div>
  );
};

export default SplashScreen;

